<script lang="ts" setup>
import FaqArticle from '~/components/FAQ/FaqArticle.vue';
import faqModelJSON from '~/../assets/faq_models/processes.json';
import { FAQMenuContent } from '~/models/faq_models';

const content = faqModelJSON as unknown as FAQMenuContent[];
</script>
<template>
  <FaqArticle type="processes" :content="content" router-articles="ProcessesArticles" />
</template>
